import { Dialog, DialogTitle, DialogActions } from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { message } from "antd";
import { useState } from "react";
import { showErrorToast } from "V2.0/utils";

export default function DocumentsDelete(props) {
  const { open, onClose, onDocumentDelete, document } = props;

  const [loading, setLoading] = useState(false);

  function handleDelete() {
    const lifecycleCbs = {
      init: () => {
        setLoading(true);
        message.loading(`Deleting ${document.referenceFor}`);
      },
      success: () => {
        message.destroy();
        message.success(`${document.referenceFor} deleted`);
        setLoading(false);
        onClose();
      },
      error: (e) => {
        message.destroy();
        setLoading(false);
        showErrorToast(e, `Failed to delete ${document.referenceFor}`);
      },
    };

    const { bucket, key } = document;

    const payload = {
      bucket,
      key,
    };

    onDocumentDelete(payload, lifecycleCbs);
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete {document?.referenceFor}?</DialogTitle>
      <DialogActions>
        <Button outline onClick={onClose}>
          Cancel
        </Button>
        <Button loading={loading} onClick={handleDelete}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
